import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SkillsPanel from "../components/SkillsPanel";
import { apiFetch, getSessionToken } from "../services/api";

/** The same workspace as the stream panel, without opening a video connection. */
export default function SessionSkills() {
  const { id = "" } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [ready, setReady] = useState<{ id: string; contextId: string; token: string } | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    setReady(null); setError("");
    void (async () => {
      try {
        const response = await apiFetch(`/sessions/${id}`);
        if (!response.ok) throw new Error("Cette session n’est pas accessible.");
        const session = await response.json();
        if (!session.context_id || !["on", "ongoing", "connecting"].includes(session.state)) {
          throw new Error("Ouvrez cette session navigateur pour utiliser ses skills.");
        }
        const token = await getSessionToken(id);
        if (!token) throw new Error("L’accès aux skills n’a pas pu être chargé. Actualisez la page.");
        if (current) setReady({ id, contextId: session.context_id, token });
      } catch (reason) {
        if (current) setError(reason instanceof Error ? reason.message : "Chargement des skills impossible.");
      }
    })();
    return () => { current = false; };
  }, [id]);
  return <main className="skills-full-workspace">
    {error ? <div role="alert"><p>{error}</p><button onClick={() => navigate("/sessions")}>Voir les sessions</button></div>
      : ready?.id === id ? <SkillsPanel sessionId={id} contextId={ready.contextId} sessionToken={ready.token}
        expanded onClose={() => navigate("/sessions")} />
      : <p role="status">Chargement des skills de la session…</p>}
  </main>;
}
